export default __webpack_public_path__ + "static/media/filled-arrow-polygon-right.f89c7f72.svg";